module.exports = __webpack_public_path__ + "static/5-57e65f9f9e33722d3cef132696ee05b1.jpg";